// What an EntityLayout hides because nothing in it is shown. Pure, like
// row-size.ts, so the rule is unit-tested without a DOM. The layout is sized
// and shaped by the fields actually SHOWN (a field hidden by its `visible`
// predicate is `display: none`), and a container of nothing must not stand:
//
// - a row whose every field is hidden is hidden itself, or it still takes the
//   layout's flex gap — a blank line per emptied row;
// - a header whose group (the items after it, up to the next header) is only
//   rows, every one hidden, is hidden: a heading over nothing.
//
// Conservative where it cannot know: a custom element or a section under a
// header may hold anything, so that header stays; a header with nothing at all
// under it, and a row that declares no field, are left as they are.

export type LayoutItemState =
    | { kind: 'header' }
    | { kind: 'row'; fields: number; shown: number }
    | { kind: 'other' };

/** For each item, in order: whether the layout hides it. */
export function hiddenLayoutItems(items: readonly LayoutItemState[]): boolean[] {
    const hidden = items.map(item => item.kind === 'row' && item.fields > 0 && item.shown === 0);
    for (let i = 0; i < items.length; i++) {
        if (items[i].kind !== 'header') continue;
        let end = i + 1;
        while (end < items.length && items[end].kind !== 'header') end++;
        const group = items.slice(i + 1, end);
        hidden[i] = group.length > 0 && group.every((item, j) => item.kind === 'row' && hidden[i + 1 + j]);
    }
    return hidden;
}
